<template>
	<page>
		<module>
			<view-list ref="view" work-type="65" dynamic-field :field-sort="false" :view-config="auth('b_defect_details_viewmanage')">
				<template #search>
					<m-search ref="search" :default-data="defaultSearchData">
						<m-search-item label="产品编号">
							<c-input name="product_code"></c-input>
						</m-search-item>
						<m-search-item label="产品名称">
							<c-input name="product_name"></c-input>
						</m-search-item>
						<m-search-item label="产品规格">
							<c-input name="product_spec"></c-input>
						</m-search-item>
						<m-search-item label="工单编号">
							<c-input name="work_code"></c-input>
						</m-search-item>
						<m-search-item label="工单状态">
							<c-select name="work_states" :options="orderStateDic" multiple></c-select>
						</m-search-item>
						<m-search-item label="工序">
							<c-select name="process_ids" async multiple @search="searchProcess" ></c-select>
						</m-search-item>
						<m-search-item label="生产人员">
							<c-select name="output_user_ids" async multiple @search="searchOutputUser" ></c-select>
						</m-search-item>
						<m-search-item label="报工审批状态">
							<c-select name="output_states" :options="auditStateDic" multiple ></c-select>
						</m-search-item>
						<m-search-item label="时间维度字段">
							<c-select name="date_field" :options="dateFieldOptions" :clear="false"></c-select>
						</m-search-item>
						<m-search-item label="时间范围">
							<c-datetime type="date" :range="freeEdition ? {limit: 30} : true" start-name="start_date" end-name="end_date" :clear="false"></c-datetime>
						</m-search-item>
						<m-search-item label="统计维度">
							<c-select name="dimension_id" :options="dimensionOption.active" :disable-options="dimensionOption.disabled" :clear="false">
								<template #option="{data, selected, disabled}">
									<select-option
										:name="data.name"
										:selected="selected"
										:vip="disabled"
									></select-option>
								</template>
							</c-select>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button v-if="auth('b_defect_details_export')" v-lock="lock('b_defect_details_export')" prepend-icon="tf-export" @click="$refs.view.exportReportByViewId()">导出</c-button>
				</template>

				<template #otherOperate>
					<c-button prepend-icon="tf-config" @click="defectsConfig()">不良品项配置</c-button>
				</template>

				<!--工单状态-->
				<template #work_state="{data}">
					<c-state dict="orderStateDic" tag :value="data.work_state"></c-state>
				</template>
				<!--任务状态-->
				<template #task_state="{data}">
					<c-state dict="orderStateDic" tag :value="data.task_state"></c-state>
				</template>
				<!--计价方式-->
				<template #pricing_type="{data}">
					<c-state dict="pricingTypeDic" tag :value="data.pricing_type"></c-state>
				</template>
				<!--工资单价-->
				<template #price="{data}">
					￥{{parseFloat(parseFloat(data.price).toFixed(6))}}
				</template>
				<!--预计工资-->
				<template #salary="{data}">
					￥{{parseFloat(data.salary).toFixed(2)}}
				</template>
				<!--报工审批状态-->
				<template #output_state="{data}">
					<c-state dict="auditStateDic" tag :value="data.output_state"></c-state>
				</template>
			</view-list>
		</module>
	</page>
</template>

<script>
	import {mapState, mapGetters} from 'vuex'

	export default {
		data() {
			let now = new Date();
			return {
				defaultSearchData: {
					dimension_id: 109,
					date_field: 'create_date',
					start_date: new Date(now.getFullYear(), now.getMonth(), now.getDate()-6).format('yyyy-MM-dd'),
					end_date: new Date().format('yyyy-MM-dd')
				}
			}
		},

		computed: {
			// 获取dictName选项数据
			...mapState(['orderStateDic', 'auditStateDic','pricingTypeDic', 'dateFieldOptions']),
			...mapGetters(['freeEdition']),

			dimensionOption() {
				let options = [
					{name: '报工',value: 109},
					{name: '工序',value: 103},
					{name: '工单',value: 110},
					{name: '产品',value: 111},
					{name: '生产人员',value: 100},
					{name: '工单+任务',value: 112},
					{name: '产品+工序',value: 113},
					{name: '产品+生产人员',value: 114}
				];

				return {
					active: options,
					disabled: this.freeEdition ? options.filter(item => item.name.includes('+')).map(item => item.value) : []
				}
			}
		},

		methods: {
			/*******搜索【工序】下拉框信息*****************/
			searchProcess(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'DICPROCESS_SEARCH',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},

			/*******搜索【员工】下拉框信息*****************/
			searchOutputUser(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'SYSUSER',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},

			//配置工序
			defectsConfig(){
				this.globalDialog('defectsConfig',{
					props: {
						type: 2
					}
				}, this.updateTableList);
			},

			/****刷新列表****/
			updateTableList() {
				//刷新表头
				this.$refs.view.updateDynamicColumn();
				//刷新表数据
				this.$refs.view.update();
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>